export default __webpack_public_path__ + "static/media/courses-white.4f8197b6.svg";